// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonService_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2.73206 5.56036.234551 3.06285C-.292479 4.63119.0686574 6.43233 1.31796 7.68163 3.07524 9.43891 5.92435 9.43891 7.68163 7.68163 9.43891 5.92435 9.43891 3.07524 7.68163 1.31796 6.43233.0686574 4.63119-.292479 3.06285.234551L5.56036 2.73206 4.85329 4.85329 2.73206 5.56036ZM14.8751 15.9993 16 14.8743 10.3753 6.99968 7.00041 10.3745 14.8751 15.9993Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.17672 8.4246L0.405761 4.65364C-0.473183 7.12336 0.0758238 9.98753 2.05278 11.9645C4.78983 14.7015 9.22745 14.7015 11.9645 11.9645C14.7015 9.22745 14.7015 4.78983 11.9645 2.05278C9.98753 0.075824 7.12336 -0.473183 4.65364 0.405761L8.4246 4.17672L7.36263 7.36263L4.17672 8.4246ZM24 22.584L15.5042 11.2564L11.2564 15.5042L22.584 24L24 22.584Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonService is a generated icon component.
 */
let IconCommonService = IconCommonService_1 = class IconCommonService extends IconBaseElement {
    render() {
        return html `${IconCommonService_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonService.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonService = IconCommonService_1 = __decorate([
    customElement('zui-icon-common-service')
], IconCommonService);
export { IconCommonService };
